var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18px","height":"18px","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"m17 13l-5 5m0 0l-5-5m5 5V6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }